import { $dailyBonusQuery } from '@/entities/navigation/store'
import { DefaultDailyBonus } from '@/widgets/dailyBonus/default'
import { FarcanaDailyBonus } from '@/widgets/dailyBonus/farcana'
import { useUnit } from 'effector-react'

export const DailyBonusView = () => {
  const dailyBonusVariant = useUnit($dailyBonusQuery)
  if (dailyBonusVariant === 'default') {
    return <DefaultDailyBonus />
  }
  if (dailyBonusVariant === 'farcana') {
    return <FarcanaDailyBonus />
  }
}
